import Layout from "@/components/layout/index.vue";
//权限管理
export default [{
    path: "/",
    name: "settingLayout",
    component: Layout,
    meta: {
        title: "配置中心"
    },
    children: [{
        path: '/setting/advertise',
        name: 'advertise',
        meta: {
            title: "广告管理"
        },
        component: () =>
            import ('@/views/setting/configure/advertise'),
    }, ]
}];